import k from "./index431.js";
import { resolveComponent as n, createElementBlock as c, openBlock as o, createElementVNode as t, createCommentVNode as a, createVNode as s, createBlock as r } from "vue";
/* empty css         */
import C from "./index231.js";
const f = ["data-component"], v = { class: "ms-header__upperSection" }, N = { class: "ms-header__upperSectionContent text-text-l" }, b = { class: "ms-header__metaActions" }, y = {
  key: 0,
  class: "ms-header__middleSection"
}, S = { class: "ms-header__middleSectionContent" }, L = {
  key: 1,
  class: "ms-header__lowerSection"
}, A = { class: "ms-header__lowerSectionContent" };
function B(e, M, E, $, I, R) {
  const l = n("ms-burger-menu-btn"), m = n("ms-header-logo"), i = n("ms-header-bookmark"), _ = n("ms-header-login"), d = n("ms-header-relocation-toggle"), h = n("ms-header-relocation"), p = n("ms-header-links"), g = n("ms-nav-bar"), u = n("ms-offcanvas-nav");
  return o(), c("header", {
    class: "ms-header",
    "data-component": e.$options.name
  }, [
    t("section", v, [
      t("div", N, [
        s(l, {
          class: "ms-header__burgerMenu",
          onClick: e.toggleBurgerMenu
        }, null, 8, ["onClick"]),
        e.isScreenL ? a("", !0) : (o(), r(m, {
          key: 0,
          class: "ms-header__logo",
          href: e.cmsContent.channelHomeUrl,
          channelName: e.cmsContent.channelName
        }, null, 8, ["href", "channelName"])),
        t("div", b, [
          e.isScreenL && e.cmsContent.headerMeta.bookmarkEnabled ? (o(), r(i, {
            key: 0,
            class: "ms-header__bookmark"
          })) : a("", !0),
          e.isScreenL && e.getLoginLink(e.cmsContent) ? (o(), r(_, {
            key: 1,
            link: e.getLoginLink(e.cmsContent),
            class: "ms-header__login"
          }, null, 8, ["link"])) : a("", !0),
          e.isRelocationEnabled ? (o(), r(d, {
            key: 2,
            onClick: e.toggleRelocation,
            location: e.getLocation(),
            class: "ms-header__relocationToggle"
          }, null, 8, ["onClick", "location"])) : a("", !0)
        ])
      ])
    ]),
    e.state.showRelocation && e.isRelocationEnabled ? (o(), c("section", y, [
      t("div", S, [
        s(h, { class: "ms-header__relocation" })
      ])
    ])) : a("", !0),
    e.isScreenL ? (o(), c("section", L, [
      t("div", A, [
        s(m, {
          class: "ms-header__logo",
          href: e.cmsContent.channelHomeUrl,
          channelName: e.cmsContent.channelName
        }, null, 8, ["href", "channelName"]),
        s(p, {
          class: "ms-header__linkArea",
          primaryAction: e.cmsContent.primaryAction,
          secondaryAction: e.cmsContent.secondaryAction,
          channelName: e.cmsContent.channelName
        }, null, 8, ["primaryAction", "secondaryAction", "channelName"]),
        s(g, {
          class: "ms-header__navBar",
          channelName: e.cmsContent.channelName,
          navigationItems: e.getMainNavigationItems()
        }, null, 8, ["channelName", "navigationItems"])
      ])
    ])) : a("", !0),
    s(u, {
      class: "ms-header__offcanvas",
      header: e.cmsContent,
      isOpen: e.state.isBurgerMenuOpen,
      onClose: e.toggleBurgerMenu
    }, null, 8, ["header", "isOpen", "onClose"])
  ], 8, f);
}
const U = /* @__PURE__ */ C(k, [["render", B], ["__scopeId", "data-v-3396afb3"]]);
export {
  U as default
};
